export default __webpack_public_path__ + "static/media/almond-3.6582bd95.webp";